import { colors } from "constants/colors";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import bt_open from "assets/images/bt_open_n.png";
import { useState } from "react";
import RoundRectangleButton from "components/atoms/RoundRectangleButton";
import RectangleButton from "components/atoms/RectangleButton";
import { useAlertStore } from "stores/alertStore";
import { toast } from "util/common";
import TextInput from "components/atoms/TextInput";
import TextInputAndLabel from "components/molecules/TextInputAndLabel";
import { API_DOMAIN, ENV } from "constants/api";
import { useAuthStore } from "stores/authStore";
import { HeaderCancelButtonComponent } from "components/molecules/Header";

function Guide() {
  const [isInfoAccordion, setIsInfoAccordion] = useState(false);
  const [isPolicyAccordion, setIsPolicyAccordion] = useState(false);
  const { showAlert } = useAlertStore();
  const [inputText, setInputText] = useState("테스트");

  const token = useAuthStore((state) => state.token);
  const userNm = useAuthStore((state) => state.userNm);
  const role = useAuthStore((state) => state.role);
  const deviceId = useAuthStore((state) => state.deviceId);
  const timezone = useAuthStore((state) => state.timezone);
  const appVersion = useAuthStore((state) => state.appVersion);
  const codepushVersion = useAuthStore((state) => state.codepushVersion);
  const osType = useAuthStore((state) => state.osType);
  const message = useAuthStore((state) => state.message);

  return (
    <>
      <HeaderCancelButtonComponent title="가이드" />
      <StyledContainer>
        <StyledPageTitle>열달후에 React web view</StyledPageTitle>

        <StyledSection>
          <StyledSectionTitle>
            <StyledTitleButton
              $isOpen={isInfoAccordion}
              onClick={() => setIsInfoAccordion(!isInfoAccordion)}
            >
              Info, state
            </StyledTitleButton>
          </StyledSectionTitle>
          <SectionAccordion $isOpen={isInfoAccordion}>
            <p>ENV: {ENV}</p>
            <p>API_DOMAIN: {API_DOMAIN}</p>
            <p>Token: {token}</p>
            <p>userNm: {userNm}</p>
            <p>role: {role}</p>
            <p>deviceId: {deviceId}</p>
            <p>timezone: {timezone}</p>
            <p>appVersion: {appVersion}</p>
            <p>codepushVersion: {codepushVersion}</p>
            <p>osType: {osType}</p>
            <p>message: {message}</p>
          </SectionAccordion>
        </StyledSection>

        <StyledSection>
          <StyledSectionTitle>공통</StyledSectionTitle>
          <div className="btn_box">
            <RectangleButton
              text="Alert"
              onClick={() => {
                showAlert({
                  message: "alert show!",
                });
              }}
              $marginLeft={20}
            />
            <RoundRectangleButton
              text="Toast"
              $marginLeft={20}
              onClick={() => {
                toast("toast show!");
              }}
            />
          </div>
          <StyledLink to="/error">에러화면</StyledLink>
          <StyledLink to="/common/comment">
            댓글 영역 (댓글 타이틀 제외)
          </StyledLink>
          {/* 인풋 테스트 */}
          <div
            style={{
              display: "flex",
              gap: 10,
              alignItems: "flex-end",
              marginTop: 30,
            }}
          >
            <TextInputAndLabel
              label="label 16 (default)"
              id="labelTest1"
              value={inputText}
              onChangeText={setInputText}
            />
            <TextInputAndLabel
              label="label 13"
              labelSize={13}
              id="labelTest2"
              isRequiredMark
              value={inputText}
              onChangeText={setInputText}
            />
            <TextInput
              id="inputTest1"
              value={inputText}
              onChangeText={setInputText}
            />
            <TextInput
              id="inputTest2"
              value={`${inputText} disabled`}
              onChangeText={setInputText}
              disabled
            />
          </div>
        </StyledSection>

        <StyledSection>
          <StyledSectionTitle>
            <StyledTitleButton
              $isOpen={isPolicyAccordion}
              onClick={() => setIsPolicyAccordion(!isPolicyAccordion)}
            >
              약관
            </StyledTitleButton>
          </StyledSectionTitle>

          <SectionAccordion $isOpen={isPolicyAccordion}>
            <StyledLink target="_blank" to="/policy/service">
              서비스 이용약관
            </StyledLink>
            <StyledLink target="_blank" to="/policy/privacy">
              개인정보 처리방침
            </StyledLink>
            <StyledLink target="_blank" to="/policy/operation">
              서비스 운영원칙
            </StyledLink>
            <StyledLink target="_blank" to="/policy/health">
              건강정보 수집·이용 동의
            </StyledLink>

            <StyledLink target="_blank" to="/policy/place">
              위치기반 서비스 이용약관
            </StyledLink>
            <StyledLink target="_blank" to="/policy/studioPrivacy">
              스튜디오_개인정보 수집∙이용 및 제3자 제공 동의
            </StyledLink>
            <StyledLink target="_blank" to="/policy/premiumService">
              프리미엄 서비스 이용약관
            </StyledLink>
            <StyledLink target="_blank" to="/policy/premiumPrivacy">
              프리미엄 개인정보 수집∙이용 및 제3자 제공 동의
            </StyledLink>
            <StyledLink target="_blank" to="/policy/studioWeeks21Privacy">
              21주 스튜디오 개인정보 제 3자 제공 동의
            </StyledLink>
            <StyledLink target="_blank" to="/policy/inboundPrivacy">
              인바운드 개인정보 제 3자 제공 동의
            </StyledLink>
            <StyledLink target="_blank" to="/policy/momsClassPrivacy">
              산모교실 개인정보 제 3자 제공 동의
            </StyledLink>

            <ul>
              <StyledListItem>
                글로벌 서비스 이용약관
                <ul>
                  <li>
                    <StyledLink target="_blank" to="/policy/en/service">
                      EN(영어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/ja/service">
                      JA(일본어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/vi/service">
                      VI(베트남어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/th/service">
                      TH(태국어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/id/service">
                      ID(인도네시아어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/es/service">
                      ES(스페인어)
                    </StyledLink>
                  </li>
                </ul>
              </StyledListItem>
              <StyledListItem>
                글로벌 개인정보 처리방침
                <ul>
                  <li>
                    <StyledLink target="_blank" to="/policy/en/privacy">
                      EN(영어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/ja/privacy">
                      JA(일본어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/vi/privacy">
                      VI(베트남어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/th/privacy">
                      TH(태국어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/id/privacy">
                      ID(인도네시아어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/es/privacy">
                      ES(스페인어)
                    </StyledLink>
                  </li>
                </ul>
              </StyledListItem>
              <StyledListItem>
                글로벌 서비스 운영원칙
                <ul>
                  <li>
                    <StyledLink target="_blank" to="/policy/en/operation">
                      EN(영어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/ja/operation">
                      JA(일본어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/vi/operation">
                      VI(베트남어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/th/operation">
                      TH(태국어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/id/operation">
                      ID(인도네시아어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/es/operation">
                      ES(스페인어)
                    </StyledLink>
                  </li>
                </ul>
              </StyledListItem>
              <StyledListItem>
                글로벌 건강정보 수집·이용 동의
                <ul>
                  <li>
                    <StyledLink target="_blank" to="/policy/en/health">
                      EN(영어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/ja/health">
                      JA(일본어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/vi/health">
                      VI(베트남어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/th/health">
                      TH(태국어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/id/health">
                      ID(인도네시아어)
                    </StyledLink>
                  </li>
                  <li>
                    <StyledLink target="_blank" to="/policy/es/health">
                      ES(스페인어)
                    </StyledLink>
                  </li>
                </ul>
              </StyledListItem>
            </ul>
          </SectionAccordion>
        </StyledSection>

        <StyledSection>
          <StyledSectionTitle>임밍아웃</StyledSectionTitle>
          <StyledLink to="/pregnancy/revealReport">임밍아웃</StyledLink>
          <StyledLink to="/pregnancy/revealReport/share">
            임밍아웃 공유
          </StyledLink>
        </StyledSection>

        <StyledSection>
          <StyledSectionTitle>이벤트 (최신순이 올라오게)</StyledSectionTitle>
          <StyledLink to="/event/kidsShare">
            우리 아이 성장 공유 이벤트
          </StyledLink>
          <StyledLink to="/event/benefit">혜택존</StyledLink>
        </StyledSection>
      </StyledContainer>
    </>
  );
}

export default Guide;

const StyledContainer = styled.div`
  margin: 24px;
  padding-top: 56px;
`;

const StyledPageTitle = styled.h1`
  font-size: 30px;
  font-weight: 500;
  line-height: 45px;
  margin-bottom: 40px;
`;

const StyledSectionTitle = styled.h2`
  display: inline-block;
  width: fit-content;
  padding: 5px 10px;
  margin-top: -35px;
  margin-left: -5px;
  font-size: 17px;
  font-weight: 500;
  line-height: 36px;
  margin-bottom: 16px;
  background-color: ${colors.lightGray1};
`;

const StyledTitleButton = styled.button<{ $isOpen: boolean }>`
  font-size: inherit;
  font-weight: inherit;
  line-height: 36px;
  &:after {
    content: "";
    display: inline-block;
    width: 36px;
    height: 36px;
    background: url(${bt_open}) no-repeat 50% / 100%;
    vertical-align: top;
    transition: transform 0.3s;
    ${({ $isOpen }) =>
      $isOpen &&
      css`
        transform: rotate(180deg);
      `};
  }
`;

const StyledSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid ${colors.lightGray1};
  &:hover {
    border-color: ${colors.subOrange4};
    ${StyledSectionTitle} {
      background-color: ${colors.subOrange4};
    }
  }
  .btn_box {
    position: absolute;
    top: -25px;
    right: 0;
    display: flex;
    flex-direction: row;
    padding: 0 20px;
  }
`;

const SectionAccordion = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: -20px 0;
  max-height: 0;
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      max-height: 2000px;
      margin: 0;
      transition: max-height 0.5s ease-in-out;
    `}
`;

const StyledLink = styled(Link)`
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  text-decoration: underline;
  &:hover {
    color: ${colors.mainOrange};
  }
`;

const StyledListItem = styled.li`
  padding: 5px;
  font-size: 20px;
  font-weight: 500;
  ul {
    padding: 10px;
  }
`;
